import { mapWaysideLandLotsMiddleware } from "./MapWaysideLandLotsMiddleware";

export const mapsMiddleware: any = [
    mapWaysideLandLotsMiddleware,
]
